import { Component, Input } from '@angular/core';

import { Router } from '@angular/router';

@Component({
  selector: 'app-policy-tiles',
  templateUrl: './policy-tiles.component.html',
  styleUrls: ['./policy-tiles.component.scss']
})
export class PolicyTilesComponent {
  @Input() data!: any;
  @Input() policy!: any;
  @Input() config!: any;

  constructor(
    private router: Router
  ) {}

  clickEvent(extra: any){
    const extraFlow = extra.settings.action.flow || '';
    if (extraFlow === 'endorsement') {
      this.router.navigate([`/endorsement/${this.policy.slug}`]);
    }
    if (extraFlow === 'info') {
      if (extra.settings.link) {
        this.router.navigate([`/policy/${this.policy?.productClass}/${this.policy?.slug}/extra/${extra.settings.link}`]);
      }
    }
  }
}
